import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
//import { Observable } from 'rxjs/Observable';
//import { Subject } from 'rxjs/Subject';
import { AppSettings } from 'read-appsettings-json';
import { UtilityServices, CheckAuth } from '../../../Services/UtilityService';

@Component({
  selector: 'app-site-admin-layout',
  templateUrl: './site-admin-layout.component.html',
  styleUrls: ['./site-admin-layout.component.css']
})
export class SiteAdminLayoutComponent implements OnInit {
  appModel: any;
  isLogin: boolean = false;
  constructor(private router: Router, private location: Location, private checkAuth: CheckAuth) {

  }

  ngOnInit() {
    this.appModel = AppSettings.Current().ConnectionStrings;
    this.GetToken();
  }

  GetToken(): void {
    this.checkAuth.GetToken();
  }
  logout(): void {
    sessionStorage.removeItem('AdminUserId');
    this.router.navigate(['admin/login']);
  }
}
